// định nghĩa các path

// export const LOGIN_API = "/sign-in";
// export const REGISTER_API = "/register";
export const API_OVERVIEW = '/tong-quan'
export const API_DASHBOARD = '/dashboard'